import styled, { css } from 'styled-components';

import { SpaceBetweenBlock } from '../../styled';

// proviers fields

export const ProviderTitle = styled.h2`
  ${(props) => props.theme.typography.subHeader2};
  margin-bottom: 4px;
`;

export const ProviderSubtitle = styled.p`
  ${(props) => props.theme.typography.description};
  color: ${(props) => props.theme.colors.muted};
  margin-bottom: 24px;
`;

export const DescriptionLink = styled.a`
  color: ${(props) => props.theme.colors.brand};
`;

export const SettingsWrapper = styled.div`
  margin-bottom: 32px;
`;

export const FieldWrapper = styled.div`
  margin-bottom: 16px;
  :last-child {
    margin-bottom: 0;
  }
`;

export const SmsProviderFieldsCard = styled.div`
  padding: 16px;
  border: 1px solid rgba(0, 36, 77, 0.05);
  box-shadow: 0 1px 4px rgba(0, 36, 77, 0.08);
  border-radius: 8px;
  margin-bottom: 32px;
  :last-child {
    margin-bottom: 0;
  }
`;

export const SmsProviderHeader = styled(SpaceBetweenBlock)`
  margin-bottom: 16px;
`;

// custom sms provider popper action

const inactiveStatusStyles = css`
  button {
    box-shadow: inset 0 0 0 1px #ffc5001f, 0 0 0 1px transparent;
    background-color: rgba(255, 197, 0, 0.12);
    border: 1px solid rgba(255, 197, 0, 0.4);
    :active {
      box-shadow: inset 0 0 0 1px #ffc500, 0 0 0 1px #ffc500;
    }
    span {
      color: #ffc500;
      border-color: rgba(255, 197, 0, 0.32);
    }
    svg {
      color: #ffc500;
    }
  }
`;

export const StatusPopper = styled.div<{ active: boolean }>`
  ${(props) => !props.active && inactiveStatusStyles};
`;
